export const getQueryString = (params: object): string => {
    const queryParams: string[] = [];
    Object.entries(params).forEach(([key, value]) => {
        if (key === "url") {
            return;
        }
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParams.length > 0 ? queryParams.join("&") : "";
};

// @ts-expect-error Check for typing
export const getQueryParameter = (name: string, url = window.top.location.href): string | null => {
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!Array.isArray(results)) {
        return null;
    }
    if (typeof results[2] !== "string") {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getRandomString = (size: number = 45): string => {
    const unreserved = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let randomString = "";
    const crypto = window.crypto;
    if (crypto) {
        const bytes: Uint8Array = new Uint8Array(size);
        crypto.getRandomValues(bytes);
        const numbers: number[] = [];
        bytes.forEach((x, i) => {
            numbers[i] = unreserved.charCodeAt(x % unreserved.length);
        });
        randomString = String.fromCharCode.apply(null, numbers);
    } else {
        while (0 < size--) {
            randomString +=
                // eslint-disable-next-line no-bitwise
                unreserved[Math.floor(Math.random() * unreserved.length) | 0];
        }
    }
    return randomString;
};

export const createHash = (str: string): string => {
    let hash = 0;
    let chr: number;
    if (str.length > 0) {
        for (let i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            // eslint-disable-next-line no-bitwise
            hash = (hash << 5) - hash + chr;
            // eslint-disable-next-line no-bitwise
            hash |= 0;
        }
    }
    return String(hash);
};

const strToBuffer = (str: string): Uint8Array => {
    const arrayBuffer = new ArrayBuffer(str.length);
    const uintArray = new Uint8Array(arrayBuffer);
    uintArray.forEach((_, i) => {
        uintArray[i] = str.charCodeAt(i);
    });
    return uintArray;
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const base64UrlEncode = (str: any): string => {
    return window.btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};

export const getCodeVerifier = (): string => {
    return base64UrlEncode(getRandomString(43));
};

export const getCodeChallenge = async (codeVerifier: string): Promise<string> => {
    try {
        const digest: ArrayBuffer = await crypto.subtle.digest("SHA-256", strToBuffer(codeVerifier));
        const digestBase64 = String.fromCharCode(...Array.from(new Uint8Array(digest)));
        return base64UrlEncode(digestBase64);
    } catch {
        return codeVerifier;
    }
};

export const getUrlOrigin = (url: string): string => {
    const regex = new RegExp("^(https?:\\/\\/[^\\/?]+)");
    const results = regex.exec(url);
    if (!Array.isArray(results)) {
        return "";
    }
    return results[1];
};

export const getOPBrowserState = (): string | null => {
    const name = "opbs=";
    const cookie = document.cookie + ";";
    const start = cookie.indexOf(name);
    if (start !== -1) {
        const end = cookie.indexOf(";", start);
        return cookie.substring(start + name.length, end);
    }
    return null;
};

const RP_IFRAME_SRCDOC_TPL = `<script type="text/javascript">
    window.poll = function () {
        var opIframe = window.parent.document.querySelector("iframe[id='OP_IFRAME_ID']");
        if (opIframe && opIframe.contentWindow) {
            opIframe.contentWindow.postMessage("OP_IFRAME_MESSAGE", "OP_IFRAME_ORIGIN");
        }
    };
</script>`;

export const getRPIframeSrcdoc = (
    config: { issuer: string; clientId: string; sessionState: string },
    opIframeId: string
): string => {
    const opIframeOrigin = getUrlOrigin(config.issuer);
    return RP_IFRAME_SRCDOC_TPL.replace("OP_IFRAME_MESSAGE", `${config.clientId} ${config.sessionState}`)
        .replace("OP_IFRAME_ORIGIN", opIframeOrigin)
        .replace("OP_IFRAME_ID", opIframeId);
};
